import React, { Component } from 'react'
import Modal from 'react-modal'
import RestApiUtils from '../../../apiclient/moebli/RestApiUtils.js'
import SendEsignConfirmationModalUI from './SendEsignConfirmationModalUI'

class SendEsignConfirmationModalSF extends Component {
  constructor(props) {
    super(props)
    this.state = {
      successMsg: null,
      errorList: null,
      submitted: false,
    }
  }

  render() {
    return (
      <SendEsignConfirmationModalUI
        context={this.props.context}
        isOpen={this.props.isOpen}
        onCancel={this.props.onCancel}
        onConfirm={this.onConfirm}
        esignSubmitted={this.state.submitted || this.props.esignSubmitted}
        successMsg={this.state.successMsg}
        errorList={this.state.errorList}
        setErrorList={this.setErrorList}
      />
    )
  }

  componentDidMount() {
    Modal.setAppElement('body')
  }

  onConfirm = () => {
    const submitted = this.state.submitted
    if (submitted) return

    this.setState({ successMsg: null, errorList: [], submitted: true })

    RestApiUtils.post(
      this.props.context,
      `/api/su/loans/${this.props.loan.loanId}/documents/${this.props.documentCode}/esign`,
      this.onSendEsignCallback,
      {}
    )
  }

  onSendEsignCallback = (response) => {
    const errorList = []
    if (response && response.errorList) {
      response.errorList.forEach(error => {
        errorList.push(error && error.message ? error.message : error)
      })
    }

    this.setState({
      successMsg: response && response.success,
      errorList: errorList,
      submitted: false,
    })

    if (response && response.errorList && response.errorList.length === 0) {
      setTimeout(() => {
        this.setState({ successMsg: null })
        this.props.onCancel()
        this.props.onRefreshClick('noBusy')
      }, 1000)
    }
  }

  setErrorList = (errorList) => {
    this.setState({ errorList: errorList })
  }
}

export default SendEsignConfirmationModalSF

